var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "hot-list" },
    [
      _vm.isInit == false
        ? _c("div", { staticClass: "no-data" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.data, function(item, key) {
        return _vm.isInit && _vm.data != ""
          ? _c(
              "dl",
              {
                key: key,
                on: {
                  click: function($event) {
                    return _vm.toInfo(item.product_type, item.product_code)
                  }
                }
              },
              [
                _c("dt", [
                  item.es_tycpfl &&
                  item.es_tycpfl == _vm.constants.ES_TYCPFL.OTC &&
                  _vm.checkLogin != true
                    ? _c("strong", [_vm._v("登录查看产品收益")])
                    : _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm._f("addunit")(
                              item.show_field_value,
                              item.show_field_unit
                            )
                          )
                        )
                      ]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(item.show_field_ms))])
                ]),
                _vm._v(" "),
                _c("dd", [
                  _c("p", [_vm._v(_vm._s(item.product_desc))]),
                  _c("span", [
                    _vm._v(
                      _vm._s(item.product_name) +
                        " • " +
                        _vm._s(item.product_code_show)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("dd", [
                  item.es_tycpfl &&
                  item.es_tycpfl == _vm.constants.ES_TYCPFL.OTC &&
                  _vm.checkLogin != true
                    ? _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.goRouter(
                                item.product_type,
                                item.product_code
                              )
                            }
                          }
                        },
                        [_vm._v("立即登录")]
                      )
                    : _c(
                        "a",
                        {
                          attrs: { href: "javascript:void(0)" },
                          on: {
                            click: function($event) {
                              return _vm.toInfo(
                                item.product_type,
                                item.product_code
                              )
                            }
                          }
                        },
                        [_vm._v("立即购买")]
                      )
                ])
              ]
            )
          : _vm._e()
      }),
      _vm._v(" "),
      _vm.isInit && _vm.data == ""
        ? _c("div", { staticClass: "no-data" }, [_vm._m(1)])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("数据加载中")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "no-inner" }, [
      _c("i", { staticClass: "icon" }),
      _vm._v(" "),
      _c("p", [_vm._v("暂无数据")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a6bb30b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a6bb30b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hotlist.vue
// module id = null
// module chunks = 